// extracted by mini-css-extract-plugin
var _1 = "FKfk_";
var _2 = "sSfr4";
var _3 = "wh20S elide";
var _4 = "N72jP visually-hidden";
var _5 = "PyxP2";
var _6 = "cRYY2";
var _7 = "vqk3_";
var _8 = "Zm87_";
var _9 = "nNkXS";
var _a = "dG45K";
export { _1 as "attribute", _2 as "base", _3 as "elide", _4 as "hide", _5 as "inline", _6 as "name", _7 as "theme-dark", _8 as "theme-light", _9 as "unit", _a as "value" }
